<template>
    <div class="audio-recorder">
        <v-btn
            v-if="!recorder"
            color="white"
            @click="start()"
            class="audio-recorder-button"
        >
            <img src="../assets/images/icon_microphone.svg" />
        </v-btn>
        <v-btn
            v-if="recorder"
            color="white"
            @click="finish()"
            class="audio-recorder-button"
        >
            <img src="../assets/images/icon_stop.svg" />
        </v-btn>
        <div
            v-if="recorder && currentRecorderTime"
            class="audio-recorder-time"
        >
            {{ currentRecorderTime }}s
        </div>
    </div>
</template>
<style scoped>
    .audio-recorder {
        display: flex;
        align-items: center;
    }

    .audio-recorder-time {
        margin-left: 10px;
        font-size: 16px;
    }

    .audio-recorder-button {
        padding: 0 !important;
        margin: 0 !important;
        min-width: 50px;
        width: 50px;
        max-width: 50px;
        min-height: 50px;
        height: 50px;
        max-height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100% !important;
    }
</style>
<script>
    import Utils from '../services/Utils'
    import MicRecorder from 'mic-recorder-to-mp3'

    export default {
        name: 'audio-recorder',
        props: ['item', 'callback', 'time'],
        data() {
            return {
                recorder: null,
                recorderPromise: null,
                startRecorderTime: null,
                currentRecorderTime: null
            }
        },
        methods: {
            start: async function () {
                const self = this

                if (self.recorder) {
                    self.stop()
                    self.start()
                    return true
                }

                try {
                    const stream = await navigator.mediaDevices.getUserMedia({
                        audio: true,
                        video: false
                    })
                    self.recorder = new MicRecorder({
                        bitRate: 128,
                        encoder: 'mp3',
                        sampleRate: 44100
                    })

                    self.recorder.start().then(() => {
                        self.startRecorderTime = Date.now()
                        self.recorderPromise = setInterval(function () {
                            self.currentRecorderTime = self.getCurrentRecorderTime()
                            if (self.time < self.currentRecorderTime) {
                                self.finish()
                            }
                        }, 1000)
                    }).catch((error) => {
                        self.reset()
                        self.$alert(
                            error.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    })
                } catch (error) {
                    self.reset()
                    self.$alert(
                        error.message,
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                }
            },
            finish: async function () {
                const self = this
                try {
                    clearInterval(self.recorderPromise)
                    if (self.recorder) {
                        const result = await self.recorder.stop()
                        result.getMp3().then(([buffer, blob]) => {
                            const reader = new FileReader()
                            reader.onload = function() {
                                self.callback(self.item, reader.result)
                            }
                            reader.readAsDataURL(blob)
                            self.reset()
                        }).catch((error) => {
                            self.reset()
                            self.$alert(
                                error.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        })
                    }
                } catch (error) {
                    self.reset()
                    self.$alert(
                        error.message,
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                }
            },
            reset: function () {
                this.recorder = null
                this.startRecorderTime = null
                clearInterval(this.recorderPromise)
            },
            getCurrentRecorderTime: function () {
                if (this.startRecorderTime) {
                    return parseInt(((Date.now()) - this.startRecorderTime) / 1000)
                }
                return null
            }
        },
    }
</script>